import {twitchEmbedUrl} from './twitchEmbed';
export function streamEmbedUrl(stream,hostname=window.location.hostname){
 if(stream?.platform==='twitch'){const value=twitchEmbedUrl(stream,hostname);if(!value)return '';const u=new URL(value);u.searchParams.set('autoplay','false');u.searchParams.set('muted','true');return u.href;}
 if(stream?.platform==='kick'){
  try{const u=new URL(stream.url);if(!['kick.com','www.kick.com'].includes(u.hostname))return '';const channel=u.pathname.split('/').filter(Boolean)[0];if(!/^[a-zA-Z0-9_-]+$/.test(channel||''))return '';return `https://player.kick.com/${encodeURIComponent(channel)}?autoplay=false&muted=true`;}catch{return '';}
 }
 return '';
}

export const streamKey = (stream) => `${stream?.user_id || ''}:${stream?.platform || ''}:${stream?.url || ''}`;
export function distinctLiveStreams(streams) {
 return Array.from(new Map((Array.isArray(streams) ? streams : []).filter(s => s?.user_id).map(s => [streamKey(s), s])).values());
}
